import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Box, Grid, useMediaQuery } from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
// component
import Stripe from "components/StripeCard/Stripe";
import { InputField, MyCheckbox } from "components";
import BackSvgComponent from "assets/icons/svg/back";
import { postalCodeLabel } from "helper/postalCodeFormat";
import { FontColors } from "theme/fontConfig";

const CreditCardList = ({
  isStripe,
  setSelectedCard,
  selectedCard,
  publicKey,
  cardList,
  isSelectedList,
  formik,
  addCardStripeRef,
}) => {
  const postalLabel = postalCodeLabel();
  const isSmallScreen = useMediaQuery("(max-width:750px)");

  const [cardLoading] = useState(false);
  const [addNewCard, setAddNewCard] = useState(false);
  const [addCardLoading, setAddCardLoading] = useState(false);

  return (
    <div className="card_num_field">
      {cardLoading ? (
        <div className="text-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          {!!cardList?.length && (
            <div
              className="cards-radio font-16 d-flex flex-column items-center "
              style={{
                gap: "10px",
                width: "max-content",
              }}
            >
              {cardList?.map((item, index) => {
                const isDisabled =
                  !isEmpty(formik?.values?.cardsDetails?.card_number) ||
                  addNewCard;

                return (
                  <div
                    data-id={item.id}
                    key={item.id}
                    onClick={() => {
                      if (isDisabled) return;
                      if (selectedCard === item.id) {
                        setSelectedCard("");
                      } else {
                        setSelectedCard(item?.id);
                      }
                    }}
                    style={{
                      width: "100%",
                      opacity: isDisabled ? 0.7 : 1,
                      pointerEvents: isDisabled ? "none" : "auto",
                      color: selectedCard !== item.id ? "#2a2a2ab3" : "#000",
                    }}
                  >
                    <p>
                      {`${item.country ?? ""} ${item.brand ??
                        ""} (${item.last4 ?? ""}), Exp: ${item.exp_month}/${
                        item.exp_year
                      }`}
                      <div className="checkbox checkbox-lg checkbox-single mr-4">
                        <input
                          type="checkbox"
                          name={`card_number${index}`}
                          id={index}
                          onChange={(e) => {
                            if (isDisabled) return;
                            setSelectedCard(e.target?.checked ? item?.id : "");
                          }}
                          checked={selectedCard === item?.id}
                          disabled={isDisabled}
                        />
                        <span />
                      </div>
                    </p>
                  </div>
                );
              })}
            </div>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            {!!cardList?.length && (
              <div
                className="card__header"
                style={{
                  width: isSmallScreen ? "100%" : "auto",
                  marginTop: isSmallScreen ? 30 : 0,
                }}
              >
                {!addNewCard && (
                  <div
                    className="add-new-payment-info"
                    onClick={() => {
                      if (isSelectedList) {
                        const newValue = !addNewCard;
                        setAddNewCard(newValue);
                        formik.setFieldValue("addCard", newValue);
                      }
                    }}
                    style={{
                      background: "#2555ef",
                      padding: "8px 15px",
                      color: FontColors.White,
                      borderRadius: 6,
                      opacity: !isSelectedList ? 0.5 : 1,
                      cursor: !isSelectedList ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="add">Use other card</span>
                  </div>
                )}
                {addNewCard && (
                  <div
                    className="cancel-add-button"
                    style={{ padding: "8px 15px" }}
                  >
                    <BackSvgComponent
                      onClick={() => {
                        setAddNewCard(false);
                        formik.setFieldValue("addCard", false);
                        formik.setFieldValue("cardsDetails", {
                          card_number: null,
                          cvc: null,
                          expMonth: null,
                          expYear: null,
                        });
                      }}
                      role="button"
                    />
                  </div>
                )}
              </div>
            )}
          </Box>

          {addNewCard && (
            <>
              {isStripe ? (
                <Grid item xs={12}>
                  <Stripe
                    loading={addCardLoading}
                    setLoading={setAddCardLoading}
                    saveCard={false}
                    ref={addCardStripeRef}
                    publicKey={publicKey}
                  />
                  <div
                    className=""
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <MyCheckbox
                      value={formik?.values?.saveCard}
                      name={"saveCard"}
                      row={true}
                      handlechange={(e) => {
                        formik.setFieldValue("saveCard", e?.target?.checked);
                      }}
                      size={"small"}
                      title="Save card"
                    />
                  </div>
                </Grid>
              ) : (
                <div className="row">
                  <div className="col-6">
                    <InputField
                      mandatory
                      {...{
                        title: "Card Number",
                        name: "card_number",
                        type: "string",
                        maxLength: 16,
                        minlength: 16,
                        pattern: "[0-9]{10}",
                        placeholderIcon: (
                          <CreditCardOutlinedIcon
                            className="card-icon"
                            fontSize="large"
                          />
                        ),
                      }}
                      id="myInput"
                      value={formik?.values?.cardsDetails?.card_number}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      handleChange={(e) => {
                        formik.setFieldValue(
                          "cardsDetails.card_number",
                          e?.target?.value
                        );
                      }}
                    />
                  </div>
                  <div className="col-3">
                    <InputField
                      mandatory
                      {...{
                        title: "Expiry Month",
                        name: `expMonth`,
                        placeholder: "MM",
                        minlength: "1",
                        maxLength: "2",
                        type: "string",
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      value={formik?.values?.cardsDetails?.expMonth}
                      handleChange={(e) => {
                        formik.setFieldValue(
                          "cardsDetails.expMonth",
                          e?.target?.value
                        );
                      }}
                    />
                  </div>
                  <div className="col-3">
                    <InputField
                      mandatory
                      {...{
                        title: "Expiry Year",
                        type: "string",
                        minlength: "4",
                        maxLength: "4",
                        name: `expYear`,
                        placeholder: "YYYY",
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      value={formik?.values?.cardsDetails?.expYear}
                      handleChange={(e) => {
                        formik.setFieldValue(
                          "cardsDetails.expYear",
                          e?.target?.value
                        );
                      }}
                    />
                  </div>
                  <div className="col-sm-4">
                    <InputField
                      mandatory
                      {...{
                        title: "CVC",
                        type: "string",
                        minlength: "3",
                        maxLength: "4",
                        name: `cvc`,
                        placeholder: "3-4 digits",
                      }}
                      value={formik?.values?.cardsDetails?.cvc}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      handleChange={(e) => {
                        formik.setFieldValue(
                          "cardsDetails.cvc",
                          e?.target?.value
                        );
                      }}
                    />
                  </div>
                  <div className="col-sm-4">
                    <InputField
                      mandatory
                      {...{
                        title: postalLabel,
                        type: "string",
                        name: `zip`,
                        placeholder: "12345",
                      }}
                      value={formik?.values?.cardsDetails?.zip}
                      handleChange={(e) => {
                        formik.setFieldValue(
                          "cardsDetails.zip",
                          e?.target?.value
                        );
                      }}
                    />
                  </div>
                  <div
                    className="col-sm-4 save-card-button"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <MyCheckbox
                      value={formik?.values?.saveCard}
                      name={"saveCard"}
                      row={true}
                      handlechange={(e) => {
                        formik.setFieldValue("saveCard", e?.target?.checked);
                      }}
                      size={"small"}
                      title="Save card"
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default CreditCardList;
